import type * as Schema from 'owa-graph-schema';
import { mapFindFolderResponseToGql } from 'owa-folder-gql-mappers';
import { default as findFolders } from '../services/findFolders';
import handleServerResponseSuccessAndError from 'owa-service-utils/lib/handleServerResponseSuccessAndError';

/**
 * Web resolver responsible for fetching folder hierarchy
 */
export const folderHierarchyWeb: Schema.ResolverFn<any, any, any, any> = async (
    parent: any,
    args: Schema.QueryFolderHierarchyArgs,
    context: any,
    info: any
): Promise<Schema.FolderHierarchyResult | null> => {
    const offset = args.offset || 0;
    const mailboxType = args.mailboxInfo.type;
    const findFolderResponseMessage = await findFolders(
        args.baseFolderDistinguishedIds,
        offset,
        args.mailboxInfo.userIdentity,
        args.mailboxInfo.mailboxSmtpAddress,
        mailboxType,
        mailboxType == 'ArchiveMailbox' // requestReplicaList
    );

    return handleServerResponseSuccessAndError(findFolderResponseMessage).then(() => {
        if (findFolderResponseMessage) {
            return mapFindFolderResponseToGql(
                findFolderResponseMessage,
                args.mailboxInfo,
                !!args.shouldShowJunkEmailFolder,
                !!args.shouldShowNotesFolder
            );
        }

        return null;
    });
};
